"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Reviews.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("8f89bc"),
    marko_node0 = marko_createElement("h6", {
        "class": "font-medium-3"
      }, "1", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Reviews & Comments"),
    marko_node1 = marko_createElement("div", {
        "class": "card d-none border round my-50"
      }, "29", null, 3, 0, {
        i: marko_const_nextId()
      })
      .e("div", {
          "class": "card-header pb-0"
        }, null, null, 3)
        .e("div", {
            "class": "avatar mr-50 align-top"
          }, null, null, 2)
          .e("img", {
              src: "/images/portrait/small/avatar-s-12.jpg",
              alt: "avtar image",
              width: "40",
              height: "40"
            }, null, null, 0)
          .e("span", {
              "class": "avatar-status-away"
            }, null, null, 0)
        .e("div", {
            "class": "d-inline-block mt-25"
          }, null, null, 2)
          .e("h6", {
              "class": "mb-0 text-bold-500 font-medium-1 font-small-3"
            }, null, null, 1)
            .t("Ananbella Queen")
          .e("p", {
              "class": "text-muted"
            }, null, null, 1)
            .e("small", null, null, null, 1)
              .t("24 mins ago")
        .e("i", {
            "class": "cursor-pointer bx bx-dots-vertical-rounded font-medium-5 float-right"
          }, null, null, 0)
      .e("div", {
          "class": "card-body py-0"
        }, null, null, 1)
        .e("p", {
            "class": "font-medium-1"
          }, null, null, 1)
          .t("Easy & smart fuzzy search🕵🏻 functionality which enables users to search quickly.")
      .e("div", {
          "class": "card-footer user-comment-footer"
        }, null, null, 3)
        .e("i", {
            "class": "cursor-pointer bx bx-comment-dots user-profile-like font-medium-4 align-middle"
          }, null, null, 0)
        .e("span", {
            "class": "ml-25"
          }, null, null, 1)
          .t("30")
        .e("span", {
            "class": "ml-1"
          }, null, null, 1)
          .t("reply"),
    marko_node2 = marko_createElement("div", {
        "class": "card d-none border round my-50"
      }, "45", null, 3, 0, {
        i: marko_const_nextId()
      })
      .e("div", {
          "class": "card-header pb-0"
        }, null, null, 3)
        .e("div", {
            "class": "avatar mr-50 align-top"
          }, null, null, 2)
          .e("img", {
              src: "/images/portrait/small/avatar-s-18.jpg",
              alt: "avtar images",
              width: "40",
              height: "40"
            }, null, null, 0)
          .e("span", {
              "class": "avatar-status-online"
            }, null, null, 0)
        .e("div", {
            "class": "d-inline-block mt-25"
          }, null, null, 2)
          .e("h6", {
              "class": "mb-0 text-bold-500 font-medium-1"
            }, null, null, 1)
            .t("Petey Cruiser")
          .e("p", {
              "class": "text-muted"
            }, null, null, 1)
            .e("small", null, null, null, 1)
              .t("21 hours ago")
        .e("i", {
            "class": "cursor-pointer bx bx-dots-vertical-rounded font-medium-5 float-right"
          }, null, null, 0)
      .e("div", {
          "class": "card-body py-0"
        }, null, null, 1)
        .e("p", {
            "class": "font-medium-1"
          }, null, null, 1)
          .t("It's more efficient 🙌 to split each route's components into a separate chunk, and only load them when the route is visited. Frest comes with built-in light and dark layouts, select as per your preference.")
      .e("div", {
          "class": "card-footer d-flex justify-content-between"
        }, null, null, 2)
        .e("div", {
            "class": "d-flex align-items-center"
          }, null, null, 2)
          .e("i", {
              "class": "cursor-pointer bx bx-comment-dots user-profile-like font-medium-4"
            }, null, null, 0)
          .e("p", {
              "class": "mb-0 ml-25"
            }, null, null, 1)
            .t("0")
        .e("div", {
            "class": "d-flex align-items-center"
          }, null, null, 2)
          .e("i", {
              "class": "cursor-pointer bx bx-share-alt font-medium-4 ml-1"
            }, null, null, 0)
          .e("span", {
              "class": "ml-25"
            }, null, null, 1)
            .t("2"),
    marko_node3 = marko_createElement("br", null, "64", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node4 = marko_createElement("div", {
        "class": "form-group row m-0 align-items-center"
      }, "65", null, 2, 0, {
        i: marko_const_nextId()
      })
      .e("div", {
          "class": "col-2 col-sm-1 px-0"
        }, null, null, 1)
        .e("div", {
            "class": "avatar"
          }, null, null, 2)
          .e("img", {
              src: "/images/profile/default.png",
              alt: "avtar images",
              width: "40",
              height: "40"
            }, null, null, 0)
          .e("span", {
              "class": "avatar-status-online"
            }, null, null, 0)
      .e("div", {
          "class": "col-10 col-sm-11 pr-0"
        }, null, null, 1)
        .e("textarea", {
            "class": "form-control form-control-lg round px-2",
            rows: "1",
            placeholder: "Add Comment",
            style: "min-height:43px;"
          }, null, null, 0),
    marko_node5 = marko_createElement("br", null, "2", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs0 = {
        "class": "card border shadow-none round my-50"
      },
    marko_attrs1 = {
        "class": "card-header pb-0"
      },
    marko_attrs2 = {
        "class": "card-body py-0"
      },
    marko_attrs3 = {
        "class": "card-footer d-flex justify-content-between"
      },
    marko_attrs4 = {
        "class": "avatar mr-50 align-top"
      },
    marko_attrs5 = {
        "class": "d-inline-block mt-25"
      },
    marko_attrs6 = {
        "class": "cursor-pointer bx bx-dots-vertical-rounded font-medium-5 float-right"
      },
    marko_attrs7 = {
        src: "/images/portrait/small/avatar-s-11.jpg",
        alt: "avtar image",
        width: "40",
        height: "40"
      },
    marko_attrs8 = {
        "class": "avatar-status-offline"
      },
    marko_attrs9 = {
        "class": "mb-0 text-bold-500 font-medium-1"
      },
    marko_attrs10 = {
        "class": "text-muted"
      },
    marko_attrs11 = {
        "class": "font-medium-1"
      },
    marko_attrs12 = {
        "class": "d-flex align-items-center"
      },
    marko_attrs13 = {
        "class": "cursor-pointer bx bx-comment-dots user-profile-like font-medium-4"
      },
    marko_attrs14 = {
        "class": "mb-0 ml-25"
      },
    marko_attrs15 = {
        "class": "d-none d-sm-block"
      },
    marko_attrs16 = {
        "class": "list-unstyled users-list m-0 d-flex align-items-center ml-1"
      },
    marko_attrs17 = {
        "data-toggle": "tooltip",
        "data-popup": "tooltip-custom",
        "data-placement": "bottom",
        title: "",
        "class": "avatar pull-up",
        "data-original-title": "Lilian Nenez"
      },
    marko_attrs18 = {
        "data-toggle": "tooltip",
        "data-popup": "tooltip-custom",
        "data-placement": "bottom",
        title: "",
        "class": "avatar pull-up",
        "data-original-title": "Alberto Glotzbach"
      },
    marko_attrs19 = {
        "data-toggle": "tooltip",
        "data-popup": "tooltip-custom",
        "data-placement": "bottom",
        title: "",
        "class": "avatar pull-up",
        "data-original-title": "Alberto Glotzbach"
      },
    marko_attrs20 = {
        "class": "d-inline-block pl-50"
      },
    marko_attrs21 = {
        src: "/images/portrait/small/avatar-s-24.jpg",
        alt: "Avatar",
        height: "30",
        width: "30"
      },
    marko_attrs22 = {
        src: "/images/portrait/small/avatar-s-25.jpg",
        alt: "Avatar",
        height: "30",
        width: "30"
      },
    marko_attrs23 = {
        src: "/images/portrait/small/avatar-s-26.jpg",
        alt: "Avatar",
        height: "30",
        width: "30"
      },
    marko_attrs24 = {
        "class": "text-muted mb-0 font-small-3"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", null, "0", component);

  out.n(marko_node0, component);

  if (input.list && input.list.length) {
    out.n(marko_node5, component);

    var $for$0 = 0;

    marko_forOf(input.list, function(review, index) {
      var $keyScope$0 = "[" + (($for$0++) + "]");

      out.e("div", marko_attrs0, "3" + $keyScope$0, component, 3)
        .e("div", marko_attrs1, "4" + $keyScope$0, component, 3)
          .e("div", marko_attrs4, "5" + $keyScope$0, component, 2)
            .e("img", marko_attrs7, "6" + $keyScope$0, component, 0)
            .e("span", marko_attrs8, "7" + $keyScope$0, component, 0)
          .e("div", marko_attrs5, "8" + $keyScope$0, component, 2)
            .e("h6", marko_attrs9, "9" + $keyScope$0, component, 1)
              .t("Jonny Richie")
            .e("p", marko_attrs10, "10" + $keyScope$0, component, 1)
              .e("small", null, "11" + $keyScope$0, component, 1)
                .t("2 hours ago")
          .e("i", marko_attrs6, "12" + $keyScope$0, component, 0)
        .e("div", marko_attrs2, "13" + $keyScope$0, component, 1)
          .e("p", marko_attrs11, "14" + $keyScope$0, component, 1)
            .t("Beautifully crafted, clean & modern designed admin✨ theme with 3 different demos & light - dark versions. Lifetime updates with new demos and features is guaranteed")
        .e("div", marko_attrs3, "15" + $keyScope$0, component, 1)
          .e("div", marko_attrs12, "16" + $keyScope$0, component, 3)
            .e("i", marko_attrs13, "17" + $keyScope$0, component, 0)
            .e("p", marko_attrs14, "18" + $keyScope$0, component, 1)
              .t("49")
            .e("div", marko_attrs15, "19" + $keyScope$0, component, 1)
              .e("ul", marko_attrs16, "20" + $keyScope$0, component, 4)
                .e("li", marko_attrs17, "21" + $keyScope$0, component, 1)
                  .e("img", marko_attrs21, "22" + $keyScope$0, component, 0)
                .e("li", marko_attrs18, "23" + $keyScope$0, component, 1)
                  .e("img", marko_attrs22, "24" + $keyScope$0, component, 0)
                .e("li", marko_attrs19, "25" + $keyScope$0, component, 1)
                  .e("img", marko_attrs23, "26" + $keyScope$0, component, 0)
                .e("li", marko_attrs20, "27" + $keyScope$0, component, 1)
                  .e("p", marko_attrs24, "28" + $keyScope$0, component, 1)
                    .t("+10 more");
    });
  }

  out.n(marko_node1, component);

  out.n(marko_node2, component);

  out.n(marko_node3, component);

  out.n(marko_node4, component);

  out.ee();
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
